import { useContext } from 'react';

import { OtpContext } from '@percent/hosted-validation-form/context/otp/OtpContext/OtpContext';

export const useOtpState = () => {
  const context = useContext(OtpContext);

  if (context === undefined) {
    throw new Error('useOtpState must be used within an OtpContextController');
  }

  return context;
};
